import Cookies from "js-cookie";
import Utils from ".";
import { IResponseRefreshToken } from "@/interfaces/IHelper";
import { ICookie } from "@/features/authentication/interfaces/IAuth";

export const onSetCookie = ({
  token,
  refresh_token,
  created_from, // Fixed loginType reference
}: ICookie) => {
  Cookies.set(
    "ai-agent-cookie",
    Utils.encryptWithAES(
      JSON.stringify({
        token: token,
        refresh_token: refresh_token,
        created_from: created_from,
      }),
    ),
    {
      expires: token.expires_in,
      secure: true,
    },
  );
};

export const onGetCookie = () => {
  const getCookie = Cookies.get("ai-agent-cookie");
  if (!getCookie) {
    console.warn("Warning: No cookie found.");
    return null;
  }

  let decryptCookie = "{}"; // Default empty object

  try {
    decryptCookie = JSON.parse(Utils.decryptWithAES(getCookie) || "{}");
  } catch (error) {
    console.error("Error decrypting cookie:", error);
    return null;
  }

  try {
    const convertJson = JSON.parse(decryptCookie);
    return convertJson as Pick<
      IResponseRefreshToken,
      "refresh_token" | "token"
    >;
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return null;
  }
};

export const onRemoveCookie = () => {
  Cookies.remove("ai-agent-cookie");
};
